import React from 'react'

import PageHeader from './components/PageHeader'
import PageFilter from './components/PageFilter'
import PageBody from './components/PageBody'
import Spinner from 'components/CommonUI/Spinner/Spinner'
import {
  getIsFetchingFilteringDataSelector,
  getIsFetchingConsamptionDataSelector,
} from 'redux/reducers/equipments'
import { useShallowEqualSelector } from 'custom-hooks'

const Equipment = () => {
  return (
    <div className="page_container equipment_page_container">
      <PageHeader />
      <PageFilter />
      <PageBody />
      <Loader />
    </div>
  )
}

const Loader = () => {
  const isFetchingFilteringData = useShallowEqualSelector(
    getIsFetchingFilteringDataSelector
  )
  const isFetchingConsamptionDataSelector = useShallowEqualSelector(
    getIsFetchingConsamptionDataSelector
  )
  return isFetchingFilteringData || isFetchingConsamptionDataSelector ? (
    <Spinner />
  ) : null
}

export default Equipment
